import type { MutableRef } from "preact/hooks";
import { useEffect } from "preact/hooks";

/** Calls `callback` when a mousedown or focus lands outside every given ref. */
export const useClickOutside = (
  refs: MutableRef<HTMLElement | null>[],
  callback: () => void
) => {
  useEffect(() => {
    const handleOutsideInteraction = (e: MouseEvent | FocusEvent) => {
      const isOutside = refs.every(
        (ref) => ref.current && !ref.current.contains(e.target as Node)
      );
      if (isOutside) {
        callback();
      }
    };

    document.addEventListener("mousedown", handleOutsideInteraction);
    document.addEventListener("focusin", handleOutsideInteraction);

    return () => {
      document.removeEventListener("mousedown", handleOutsideInteraction);
      document.removeEventListener("focusin", handleOutsideInteraction);
    };
  }, [refs, callback]);
};
